import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import {
  EMPTY_GUEST_FORM,
  GuestDetailsForm,
  guestCreatePayloadToApi,
} from "@/components/guests/GuestDetailsForm";
import { api } from "@/lib/apiClient";
import type { Guest, GuestCreatePayload } from "@/types/camping";

export interface CreateGuestModalProps {
  open: boolean;
  onClose: () => void;
  onCreated: () => void;
}

export function CreateGuestModal({ open, onClose, onCreated }: CreateGuestModalProps) {
  const [form, setForm] = useState<GuestCreatePayload>(EMPTY_GUEST_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setForm(EMPTY_GUEST_FORM);
    setError(null);
    setSubmitting(false);
  }, [open]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.post<Guest>("/api/v1/guests", guestCreatePayloadToApi(form));
      onCreated();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Fehler beim Anlegen");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Neuer Gast"
      description="Gast in der Stammkartei anlegen"
      size="lg"
    >
      <form onSubmit={(e) => void onSubmit(e)} className="space-y-4">
        <GuestDetailsForm guest={form} onChange={setForm} autoFocusFirst />
        {error ? <p className="text-sm text-status-red">{error}</p> : null}
        <div className="eh-modal-actions flex flex-wrap justify-end gap-2 border-t border-separator pt-4">
          <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>
            Abbrechen
          </Button>
          <Button type="submit" loading={submitting}>
            Gast anlegen
          </Button>
        </div>
      </form>
    </Modal>
  );
}
